<main id="main-content" class="h-screen flex flex-col pl-8 py-4 pr-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <div class="w-full flex gap-2 items-center justify-start">
                <h1 class="oswald-font text-3xl uppercase">
                    Assessment
                </h1>
                <div data-popover-target="popover-right" data-popover-placement="right" type="button">
                    <lucide-icon [name]="icons.CircleHelp" [size]=24 class="text-red-500"></lucide-icon>
                </div>
                <div data-popover id="popover-right" role="tooltip" class="absolute z-10 invisible inline-block w-[600px] text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">
                    <div class="px-3 py-2">
                        <p>
                            To send out an assessment, click on any of the orange buttons below. In the pop-up, enter the email address of the person for which you would like to send out the survey. 
                        </p>
                        <p>
                            To preview a submitted survey, click on 
                            <span class="inline-flex w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center">
                                <lucide-icon [img]="icons.FileText" size="20"></lucide-icon>
                            </span>. To download the submitted survey, click on 
                            <span class="inline-flex w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center">
                                <lucide-icon [img]="icons.Download" size="20"></lucide-icon>
                            </span>.
                        </p>
                    </div>
                    <div data-popper-arrow></div>
                </div>
            </div>
            <eop-assistant
                [sectionId]="sectionType"
            ></eop-assistant>         
        </div>
        <div class="w-full flex flex-row items-center justify-between gap-3">
            <button 
                *ngIf="canSave()"
                (click)="$event.preventDefault(); handleOpenModal('send-assess', 'Site');"
                class="w-full h-full flex flex-row gap-2 items-center justify-center px-4 py-2 rounded-full bg-gradient-to-b from-nside-orange-300 to-nside-orange-400  hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 text-white text-sm"
            >  
                <lucide-icon [name]="icons.Mail" [size]="24"></lucide-icon>
                Send Site Assessment
            </button>
            <button
                *ngIf="canSave()"
                (click)="$event.preventDefault(); handleOpenModal('send-assess', 'Capacity');"
                class="w-full h-full flex flex-row gap-2 items-center justify-center px-4 py-2 rounded-full bg-gradient-to-b from-nside-orange-300 to-nside-orange-400  hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 text-white text-sm"
            >  
                <lucide-icon [name]="icons.Mail" [size]="24"></lucide-icon>
                Send Capacity Assessment
            </button>
            <button
                *ngIf="canSave()"
                (click)="$event.preventDefault(); handleOpenModal('send-assess', 'Climate');" 
                class="w-full h-full flex flex-row gap-2 items-center justify-center px-4 py-2 rounded-full bg-gradient-to-b from-nside-orange-300 to-nside-orange-400  hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 text-white text-sm"
            >  
                <lucide-icon [name]="icons.Mail" [size]="24"></lucide-icon>
                Send Climate Assessment
            </button>
            <button
                *ngIf="hasnSideAssess == '1'"
                (click)="$event.preventDefault(); goToThreatAssess();"
                class="w-full h-full flex flex-row gap-2 items-center justify-center px-4 py-2 rounded-full bg-gradient-to-b from-nside-orange-300 to-nside-orange-400  hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 text-white text-sm"
            >  
                <lucide-icon [name]="icons.Navigation" [size]="24"></lucide-icon>
                Navigate to Threat Assessment
            </button>
        </div>
    </div>
    
    <!-- MAIN CONTENT -->
    <div class="p-2 w-full flex flex-grow flex-col items-start gap-8 overflow-y-auto">
        <div class="max-h-full w-full flex flex-col gap-4">
            <div class="h-full w-full bg-white rounded-md shadow-custom-2 flex flex-col items-center justify-center p-6 gap-4">
                <div class="w-full h-10 flex items-center justify-between gap-4">
                    <div class="relative w-full">
                        <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                            <lucide-icon [img]="icons.Search"></lucide-icon>
                        </div>
                        <input noEmoji 
                            type="search" 
                            class="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500" 
                            [(ngModel)]="searchQuery" 
                            (input)="filterSchedulesList()"
                            placeholder="Search..."  />
                    </div> 
                    <div class="h-full relative">
                        <button id="schoolYearDropdownButton" type="button"
                            class="flex items-center justify-center gap-2 px-2 h-full rounded-md border border-gray-300 bg-gray-50 whitespace-nowrap"
                            (click)="$event.preventDefault(); toggleSchoolYearDropdown()">
                            {{ selectedSchoolYear }}
                            <svg class="w-2.5 h-2.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 10 6">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="m1 1 4 4 4-4" />
                            </svg>
                        </button>
    
                        <div id="schoolYearDropdown" *ngIf="isSchoolYearDropdownOpen"
                            class="absolute top-full mt-1 z-20 divide-y divide-gray-300 bg-orange-50 rounded-md w-full shadow-md">
                            <ul class="py-2">
                                <li *ngFor="let year of schoolYears">
                                    <a href="#" class="block px-4 py-2 hover:bg-white hover:text-nside-orange-400"
                                        (click)="$event.preventDefault(); handleSchoolYearSelect(year);">
                                        {{ year }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="assessmentsList.length > 0; else emptyAssessCases">
                    <div class="w-full h-full overflow-y-auto">                        
                            <div class="h-full w-full overflow-y-auto">
                                <table class="w-full text-left">
                                    <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                                        <tr>
                                            <th scope="col" class="px-4 py-3 py-3 w-10">
                                                <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                                    No.
                                                </div>
                                            </th>
                                            <th scope="col" class="px-4 py-3 w-1/4">
                                                <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                                    Type
                                                    <lucide-icon
                                                        (click)="$event.preventDefault(); sortList('type_name')"
                                                        [img]="icons.ArrowUpDown" size="18"
                                                    ></lucide-icon>
                                                </div>
                                            </th>
                                            <th scope="col" class="px-4 py-3 w-1/4">
                                                <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                                    Sub Type
                                                    <lucide-icon
                                                        (click)="$event.preventDefault(); sortList('sub_type_name')"
                                                        [img]="icons.ArrowUpDown" size="18"
                                                    ></lucide-icon>
                                                </div>
                                            </th>
                                            <th scope="col" class="px-4 py-3 w-1/4">
                                                <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                                    Date Requested
                                                    <lucide-icon
                                                        (click)="$event.preventDefault(); sortList('type_name')"
                                                        [img]="icons.ArrowUpDown" size="18"
                                                    ></lucide-icon>
                                                </div>
                                            </th>
                                            <th scope="col" class="px-4 py-3 w-1/4">
                                                <div class="flex items-center justify-start gap-1 cursor-pointer">
                                                    Requested To
                                                    <lucide-icon
                                                        (click)="$event.preventDefault(); sortList('type_name')"
                                                        [img]="icons.ArrowUpDown" size="18"
                                                    ></lucide-icon>
                                                </div>
                                            </th>
                                            <th scope="col" class="px-4 py-3 w-32">
                                                <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                                    Actions
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let assess of assessmentsList | paginate: { itemsPerPage: itemsPerPage, currentPage: page }; let i=index;" class="bg-white border-b">
                                            <th scope="row" class="px-4 py-4">
                                                {{ i + 1 + (page - 1) * itemsPerPage }} 
                                            </th>
                                            <td class="px-4 py-4 font-medium">
                                                {{ assess.type_name }}
                                            </td>
                                            <td class="px-4 py-4 font-medium">
                                                {{ assess.sub_type_name }}
                                            </td>
                                            <td class="px-4 py-4 font-medium">
                                                {{ assess.date_sent | date: 'MM/dd/yyyy - HH:mm' }}
                                            </td>
                                            <td class="px-4 py-4 font-medium">
                                                {{ assess.receiver }}
                                            </td>
                                            <td class="px-4 py-4 flex items-center justify-start gap-1">
                                                <button 
                                                    [attr.data-tooltip-target]="'tooltip-' + assess.id + '-preview'"  data-tooltip-placement="bottom"
                                                    class="w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center hover:text-white hover:bg-nside-gray-200"
                                                    (click)="$event.preventDefault(); handleOpenModal('assess-details', assess);"
                                                >
                                                    <lucide-icon [img]="icons.FileText" size="20"></lucide-icon>
                                                </button>
                                                <div [id]="'tooltip-' + assess.id + '-preview'" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                                                    Preview
                                                    <div class="tooltip-arrow" data-popper-arrow></div>
                                                </div>
                                                <button 
                                                    *ngIf="assess.guid"
                                                    [attr.data-tooltip-target]="'tooltip-' + assess.id + '-download'" data-tooltip-placement="bottom"
                                                    class="w-8 h-8 rounded border-2 flex items-center justify-center"
                                                    [ngClass]="{
                                                        'border-gray-200 text-gray-200 cursor-not-allowed': assess.submitted == 0,
                                                        'border-nside-gray-200 text-nside-gray-200 hover:text-white hover:bg-nside-gray-200': assess.submitted == 1
                                                    }"
                                                    (click)="$event.preventDefault(); downloadSurvey(assess.guid);"
                                                    [disabled]="assess.submitted == 1 && !assess.guid"
                                                >
                                                    <lucide-icon [img]="icons.Download" size="20"></lucide-icon>
                                                </button>
                                                <div [id]="'tooltip-' + assess.id + '-download'" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                                                    Download
                                                    <div class="tooltip-arrow" data-popper-arrow></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        
                    </div>
                    <div class="w-full flex justify-between items-center">
                        <p>{{ assessmentsList.length }} in total</p>
                        <pagination-controls
                            *ngIf="assessmentsList.length > itemsPerPage" 
                            (pageChange)="page = $event"
                            previousLabel="Prev"
                            nextLabel="Next"
                            class="mt-2"
                        ></pagination-controls>
                    </div>
                </ng-container>
                <ng-template #emptyAssessCases>
                    <p class="w-full text-start text-nside-gray-100 italic">
                        Empty List
                    </p>
                </ng-template>
            </div>
        </div>
    </div>

    <introduction></introduction>

    <send-assessment
        *ngIf="showSendAssess && selectedAssessType"
        [assessType]="selectedAssessType"
        (onClose)="handleCloseModal('send-assess')"
        (onSave)="handleSave($event, 'send-assess')"
    ></send-assessment>

    <assess-details
        *ngIf="showAssessDetails && selectedAssess"
        [asessDetails]="selectedAssess"
        (onClose)="handleCloseModal('assess-details')"
        (onDelete)="handleOpenModal('delete-confirmation');"
    ></assess-details>

    <delete-confirmation
        *ngIf="showDeleteConfirmation"
        [text]="'this assessment'"
        [itemToDelete]="selectedAssess"
        (onClose)="handleCloseModal('delete-confirmation')"
        (onDelete)="handleDelete($event)"
    ></delete-confirmation>

    <prv-next-buttons [totalPages]="(eopNavigationService.totalPages$ | async) || []" />

    <popup-message 
        [type]="messageModal"
        [message]="popupMessage"
        (close)="resetMessageModal()"
    ></popup-message>

    <!-- Spinner -->
    <div *ngIf="loading">
        <spinner></spinner>
    </div>
</main>